import { createAction, props } from "@ngrx/store";
import { ProductDto } from "../interfaces/product_dto";

export const upsertProduct = createAction(
    "[Products] Upsert Product",
    props<{ product: ProductDto }>()
);

export const upsertProductSuccess = createAction(
    "[Products] Upsert Product Success",
    props<{ product: ProductDto }>()
);

export const loadProducts = createAction(
  "[Products] Load Products",
);

export const loadProductsSuccess = createAction(
    "[Products] Load Products Success",
    props<{ products: ProductDto[] }>()
);

export const deleteProduct = createAction(
    "[Products] Delete Product",
    props<{ productId: number }>()
);

export const deleteProductSuccess = createAction(
    "[Products] Delete Product Success",
    props<{ productId: number }>()
)
